import { Injectable } from '@angular/core';
import {
    HTTPWrapperContext,
    XHR_STRATEGIES,
    REQUEST_METHODS,
    RequestConfigImplementation,
    NormalizedResponse
} from '@ptl/xhr';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';

import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { environment } from 'src/environments/environment';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { FormConfig, FormNavigationConfig } from '@ptl/forms';
import { EnrollmentSubmissionService, SubmitAppResponse } from 'src/app/angular-elements/shared/services/enrollment/enrollment-submission.service';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { OnExchangePlanAttributes, PlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { PlanUtilityService } from 'src/app/angular-elements/plan-selection/plan-summary-list/plan-utility.service';
import { PlansStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface';
import { BrandingConfigurationService } from '@ptl/brand';
import { BasicUserInfo, ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LoggedInUserInformationService, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { DateService } from 'src/app/shared/services/date.service';
import { PtlWindowLocationService } from '@ptl/global-components';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME, ProspectState } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { EligibilityResponsePayload } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/eligibility.interface';
import {
    OnExchangeEnrollRequestPayload,
    TransactionGroup,
    Applicant as OnExchangeEnrollApplicant,
    Agent,
    AffectedInsurancePremium
} from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-enrollment.request-payload.interface';

import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { OnExchangeEnrollmentNormalizedResponse, OnExchangeEnrollResponse } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-enrollment.response-payload.interface';
import { APPLICANT_RELATION } from 'src/app/angular-elements/plan-selection/services/interfaces/shared/plan-demographics/applicant.interface';
import { EnrollmentAppStateStructure } from '../../../interfaces/enrollmentAppStateStructure.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DOCUMENT_UPLOAD_TYPES, LifeEventStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/life-event.state-structure.interface';
import { SpecialEnrollmentCircumstance } from 'src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface';
import { ENROLLMENT_CHANNEL, EnrollmentApplicationSEPData, EnrollmentApplicationSubscriberPerson, EnrollPayloadRequest, EnrollPayloadSaveRequest, EnrollPayloadSubmitRequest, ProductData } from '../../../interfaces/enrollment-submission.interface';
import { IS_HISPANIC, NON_HISPANIC_RACE_ETHNICITY } from 'src/app/shared/enums/race-ethnicity.enum';
import { PLAN_STATE_NAME } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';
import { PLAN_DETAILS_STATE_NAME } from 'src/app/angular-elements/plan-selection/configs/reducers/plan-details.reducer';
import { INDIVIDUAL_MARKET_STATE_NAME } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/reducers/individual-market.reducer';
import { AgentInfo } from '../../../interfaces/agent-info.interface';
import { ZIP_COUNTY_STATE_NAME } from 'src/app/angular-elements/demographics/zip-county-modal/reducers/zipCounty.reducer';
import { SAVED_QUOTES_REDUCER_NAME } from 'src/app/angular-elements/producer/saved-quotes/reducers/saved-quotes.reducer';
import { SavedQuotesStateStructure } from 'src/app/angular-elements/producer/saved-quotes/interfaces/savedQuotesStateStructure.interface';
import { ConsumerNpnControlsAsJson, OnExchangeEligibilityFormStateStructure } from '../../../interfaces/on-exchange-eligibility-form.interface';
import { ENROLLMENT_APP_STATE_NAME, saveApplicationSubmissionInfo, saveExtraInfo } from 'src/app/shared/reducers/enrollmentApp.reducer';
import { ON_EXCHANGE_ELIGIBILITY_FORM_REDUCER_NAME } from 'src/app/shared/reducers/on-exchange-eligibility-form.reducer';
import { GlobalDataStateStructure, URL_PARAM_REFERRAL_TYPE } from '../../../components/configs/interfaces/globalStateStructure.interface';
import { ProducerUrlSessionObject } from 'src/app/angular-elements/producer/passive-referral-loader/interfaces/passive-referral-loader.interface';
import { PrePopulatedDataStateStructure } from '../../../components/configs/interfaces/prePopulatedDataStateStructure.interface';

//import * as moment from 'moment';
import moment from 'moment';
import { EBillTransferResponseInterface } from 'src/app/shared/interfaces/eBill/transfer.response.interface';
import { PlanDetailsStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/planDetailsStateStructure.interface';
import { ENROLLMENT_FLOW } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum';
import { SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_NAME } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/reducers/special-enrollment-circumstance.reducer';
import { SaveQuoteMetaData, SaveQuoteDataUrls, SaveQuoteDataLockedInStateStructure, SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS } from 'src/app/angular-elements/producer/saved-quotes/interfaces/save-quote-data.interface';
import { LIFE_EVENT_DOCUMENT_UPLOAD_REDUCER } from '../../../components/configs/reducers/life-event.reducer';
import { IndividualMarketStateStructure } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';
import { eSignatureFieldFormProducer, eSignatureFieldFormSpouse, eSignatureFieldFormSubscriber, eSignatureFieldPayload, EthnicBackground, Person } from 'src/app/angular-elements/form-wrappers/form-components/individual-market-persons/interfaces/person.interface';
import { SpecialEnrollmentCircumstanceStateStructure } from 'src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/special-enrollment-circumstance.StateStructure.interface';
import { APP_STATUS } from 'src/app/angular-elements/producer/enums/app-status.enum';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';
import { EFFECTIVE_DATE_STATE_NAME } from '../../../components/configs/reducers/effective-date.reducer';
@Injectable({
    providedIn: 'root'
})
export class IndividualMarketsEnrollmentSubmissionService {
    forceValues = false;

    constructor(
        private ngRedux: NgRedux<StateStructure>,
        private httpClient: HTTPWrapperContext,
        private reducerUtilityService: ReducerUtilityService,
        private electionQuestionsService: EnrollmentSubmissionService,
        private planUtilityService: PlanUtilityService,
        private brandService: BrandingConfigurationService,
        private loggedInUserService: LoggedInUserInformationService,
        private dateService: DateService,
        private windowLocationService: PtlWindowLocationService,
        private commonUtilityService: CommonUtilityService,
        private date: DateService,
        private snackBar: MatSnackBar,
        private eligibilityManagerService: EligibilityManagerService,
        private entitlementsHelperService: EntitlementsHelperService
    ) { }


    plansFromState = this.planUtilityService.getPlansByProductGroupAsArray();
    zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');
    
    productGroup = PRODUCT_GROUPS.MEDICARE_ADVANTAGE;
    productType: PRODUCT_GROUPS;

    isSavedApp: boolean = false; 
    quoteButtonPage: string = 'enrollPage';

    async generateApp(individualMarketInfo: IndividualMarketStateStructure): Promise<EnrollPayloadRequest> {
        let individualPlanPayload: EnrollPayloadRequest = {} as EnrollPayloadRequest;
        const enrollment = individualMarketInfo.enrollment || {};

        individualPlanPayload.enrollment = enrollment;
        // individualPlanPayload.submitStatus = status;
        individualPlanPayload.ddValue = this.brandService.getCurrentBrand().ddToken;
        individualPlanPayload.ubk = this.zipCountyState.county.ubk;
        individualPlanPayload.market = 'INDIVIDUAL'; 

        /** GET STATES */
        const componentStates = this.reducerUtilityService.getComponentStates();
        const payloadStates = this.reducerUtilityService.getPayloadStates();
        const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
        const globalData: GlobalDataStateStructure = this.reducerUtilityService.getState('GlobalData');
        const passiveReferralData: ProducerUrlSessionObject = this.reducerUtilityService.getState('PassiveReferrals')

        const applicantsInfo: Person[] = [];

        /** Subscriber */
        if (individualMarketInfo.ratingInfo.subscriber?.[0]) {
            let subscriberInfo = this.getSubscriberData(individualMarketInfo);
            applicantsInfo.push(subscriberInfo)
        }

        /** Spouse/Domestic Partner */
        if (individualMarketInfo?.ratingInfo?.['spousal-partner']?.[0]?.dob) {
            let spouseInfo = this.getSpouseData(individualMarketInfo);
            applicantsInfo.push(spouseInfo);
        }

        /** Enrollment Data */

        if (enrollment?.ohpReplaceEffectiveDate) {
            enrollment.ohpReplaceEffectiveDate = this.date.getDateAsFormattedString(enrollment.ohpReplaceEffectiveDate, 'MM/DD/YYYY');
        }
        if (enrollment?.ohpReplacePolicyHolderDob) {
            enrollment.ohpReplacePolicyHolderDob = this.date.getDateAsFormattedString(enrollment.ohpReplacePolicyHolderDob, 'MM/DD/YYYY');
        }
        if (enrollment && enrollment['ohpP&GEffectiveDate']) {
            enrollment['ohpP&GEffectiveDate'] = this.date.getDateAsFormattedString(enrollment['ohpP&GEffectiveDate'], 'MM/DD/YYYY');
        }
        if (enrollment && enrollment['ohpP&GPolicyHolderDob']) {
            enrollment['ohpP&GPolicyHolderDob'] = this.date.getDateAsFormattedString(enrollment['ohpP&GPolicyHolderDob'], 'MM/DD/YYYY');
        }

        /** ICHRA / QSEHRA flags */
        const ichraFieldName = 'ichra';
        const qsehraFieldName = 'qsehra';

        const isICHRAPayment = enrollment.payerType?.toUpperCase() === ichraFieldName.toUpperCase();
        const isQSEHRAPayment = enrollment.payerType?.toUpperCase() === qsehraFieldName.toUpperCase();
        if (isICHRAPayment || isQSEHRAPayment) {
            enrollment[ichraFieldName] = isICHRAPayment;
            enrollment[qsehraFieldName] = isQSEHRAPayment;
        }

        if (enrollment.premiumPayment === 'N/A') {
            enrollment.premiumPayment = true;
        }

        enrollment.childOnlyPolicy = false;
        if (individualMarketInfo.childOnlyPolicy === 'Yes') {
            enrollment.childOnlyPolicy = true;
        }

        this.removeEmptyKeys(enrollment);

        enrollment.enrollmentChannel = ENROLLMENT_CHANNEL.CONSUMER;


        /** Dependent(s) */
        if (individualMarketInfo.ratingInfo && individualMarketInfo.ratingInfo.dependents) {
            applicantsInfo.push(...this.getDependentData(individualMarketInfo));
        }
        if (this.commonUtilityService.isAgent()) {

            const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
            const lob: LINE_OF_BUSINESS_ENUM = await this.entitlementsHelperService.getCurrentLobPromise();

            const retailStoreEntitlement = await this.entitlementsHelperService.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.RETAIL_STORE, lob, loginInfo?.userInfo?.role as USER_ROLE);
            const TelesalesAgentDPEntitlement = await this.entitlementsHelperService.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.TELESALES_AGENT_DP, lob, loginInfo?.userInfo?.role as USER_ROLE);

            const channelToUse = retailStoreEntitlement ? ENROLLMENT_CHANNEL.AGENT_RETAIL : TelesalesAgentDPEntitlement ? ENROLLMENT_CHANNEL.AGENT_TELESALES : ENROLLMENT_CHANNEL.AGENT_GENERIC;

            if (enrollment) {
                enrollment.enrollmentChannel = channelToUse;
            }

        }

        individualPlanPayload.applicant = applicantsInfo;
        individualPlanPayload.enrollment['productData'] = {} as ProductData;
        individualPlanPayload.productType = planState.activeProductGroup;
        individualPlanPayload.productDescription = planState.activeProductGroup;

        const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilityService.getState('PrePopulateData');
        individualPlanPayload.salesforceAccountId = prePopulateData.prepopulatedFields && prePopulateData.prepopulatedFields.salesforceAccountId;
        individualPlanPayload.salesforceOpportunityId = prePopulateData.prepopulatedFields && prePopulateData.prepopulatedFields.salesforceOpportunityId;

        
        /** Application Tracking Id */
        let enrollmentStateStructure: EnrollmentAppStateStructure = this.reducerUtilityService.getState(ENROLLMENT_APP_STATE_NAME);
        if (enrollmentStateStructure.appId) {
            individualPlanPayload.applicationTrackingId = enrollmentStateStructure.appId;
        }

        /** Plan Data */
        if (this.plansFromState.length !== 0) {

            /** 
             * Few cases exist where you need to populate these selectedPlan value:
             * 1) You are doing a normal flow - you've hit the ENROLL BUTTON, you've assigned a planidForEnrollment - you fetch a single plan
             * 2) You are doign a saved quote flow 
             * 2a) From PLAN DETAILS - you are reviewing 1 plan, but you haven't hit the ENROLL BUTTON - so no planIdForEnrollment - get value from saveQuoteData state ( contains all the plans reducers )
             * 2b) From COMPARE PLANS - you are reviewing 2+ plans, you haven't hit the ENROLL BUTTON - so no planIdForEnrollment - DO NOT save a selected plan ( saving a selected plan results in a display of premium data - which would be inaccurate for multiple plans )
             * 3a) From DOCUMENT UPLOAD PROMPT - you MAY have a plan selected or you MAY be reviewing a plan - so no planIdForEnrollment is guaranteed - get value from saveQuoteData state
             * 4) PLAN_DETAILS_STATE_NAME reducer has no data ( meaning you didn't interact w/ plan details ) and thus, there is no heavy-detail plan info; use instead the light-detail plan info ( planIdForEnrollment available here )
             */
            let selectedPlan: Product<PlanAttributes, SummaryView>;
            
            // SAVED QUOTE
            if (this.isSavedApp) {
                const planDetailsState: PlanDetailsStateStructure = this.reducerUtilityService.getState(PLAN_DETAILS_STATE_NAME);
                if (planDetailsState.planDetails) {
                    const plansInState = this.planUtilityService.getPlanDetailsByProductGroupAsArray();

                    // PLAN DETAILS
                    if (plansInState.length === 1) {
                        selectedPlan = this.planUtilityService.getPlanDetailsByProductGroupAsArray()[0];
                    }
                    // COMPARE PLANS
                    else {
                        // Don't save a 'selected plan'
                    }
                }
            }

            // ENROLL FLOW ( without going through plan details )
            if (!selectedPlan) {
                selectedPlan = this.plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment)[0];
            }
                
                
            if (selectedPlan) {
                const productInfo = {
                    planId: null,
                    planName: null,
                    cmsPlanID: null,
                    pbpId: null,
                    segmentId: null,
                    groupNo: null,
                    newGroupNo: null,
                    superProductId: null,
                    monthlyPremium: null,
                    planDetails: null,
                    subName: ""
                };

                try {

                    const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');

                    let region = '';
                    if (zipCountyState) {
                        region = zipCountyState.county && zipCountyState.county.region;
                    }

                    /** ARCHIVAL PLAN-DETAILS TO BE STORED - not read on backend */
                    productInfo.planDetails = selectedPlan;

                    // Single-Attributes, specifically named - actually read on backend

                    /** Product Info */
                    productInfo['groupNumber'] = selectedPlan.attributes?.GROUP_NO;
                    productInfo['merchantId'] = selectedPlan.attributes?.BILL_MERCHANT_NAME;
                    productInfo['region'] = region;
                    productInfo['lob'] = selectedPlan.attributes?.LINE_OF_BUSINESS;
                    productInfo['planArea'] = selectedPlan.attributes?.PLAN_AREA;
                    productInfo['planId'] = selectedPlan.attributes?.PLAN_ID;
                    // Subname is the place where the string has digit with a space in front of it.
                    const nameBreakdown = /(.*?)\s(\d+\s?.*)/.exec(selectedPlan.attributes?.PRODUCT_NAME);
                    const subName = nameBreakdown?.[2];
                    productInfo.planName = nameBreakdown?.[1] || selectedPlan.attributes?.PRODUCT_NAME;
                    productInfo.subName = subName || "";

                    productInfo['hiosId'] = selectedPlan.attributes?.HIOS_ID;
                    productInfo['ratingEntity'] = selectedPlan.attributes?.RATING_ENTITY;
                    productInfo['premiumAmount'] = '$' + selectedPlan?.price;

                } catch (e) {
                    console.warn('Did you set the selected product?', productInfo, e);
                }

                switch (productInfo.planDetails.attributes.PRODUCT_GROUP.toUpperCase()) {
                    case PRODUCT_GROUPS.OFF_EXCHANGE.toUpperCase():
                        // productType is purposefully assigned from PRODUCT_GROUPS, this is not a typoe
                        individualPlanPayload.productType = PRODUCT_GROUPS.OFF_EXCHANGE;
                        individualPlanPayload.productDescription = PRODUCT_GROUPS.OFF_EXCHANGE;
                        break;
                    case PRODUCT_GROUPS.DENTAL.toUpperCase():
                        // productType is purposefully assigned from PRODUCT_GROUPS, this is not a typoe
                        individualPlanPayload.productType = PRODUCT_GROUPS.DENTAL;
                        individualPlanPayload.productDescription = PRODUCT_GROUPS.DENTAL;
                        break;
                    case PRODUCT_GROUPS.BLUE_EDGE_BALANCE.toUpperCase():
                        // productType is purposefully assigned from PRODUCT_GROUPS, this is not a typoe
                        individualPlanPayload.productType = PRODUCT_GROUPS.BLUE_EDGE_BALANCE;
                        individualPlanPayload.productDescription = PRODUCT_GROUPS.BLUE_EDGE_BALANCE;
                        break;
                    default:
                        this.productGroup = this.productType = null;
                        break;
                }

                individualPlanPayload.enrollment['productData'] = productInfo;
            }
        }

        /** Effective Date */
        const effDate = payloadStates.individualMarket.ratingInfo.effectiveDate;
        individualPlanPayload.enrollment.effectiveDate = this.date.getDateAsFormattedString(effDate, 'MM/DD/YYYY');

        /** Special Enrollment Data */
        const specialEnrollmentState: SpecialEnrollmentCircumstance = payloadStates['special-enrollment-circumstance'];

        const specialEnrollmentDocumentationState: LifeEventStateStructure = componentStates['LifeEvent'];


        if (specialEnrollmentState?.isApplicableCircumstance?.toUpperCase() === 'Yes'.toUpperCase()) {
            individualPlanPayload.enrollment.sepInformation = this.getSEPData({
                specialEnrollmentState: specialEnrollmentState,
                specialEnrollmentDocumentationState: specialEnrollmentDocumentationState,
                effDate: effDate,
                individualMarketInfo: individualMarketInfo
            });
        }

        if (globalData?.urlParams?.referralid || passiveReferralData?.referralId){
            individualPlanPayload.referralid = globalData.urlParams.referralid || passiveReferralData?.referralId;
        }

        /** Data coming from QUOTE DASHBOARDS or EMAILED CONSUMER DOCUMENT-UPLOAD REQUESTS */
        const savedQuotesData: SavedQuotesStateStructure = this.reducerUtilityService.getState(SAVED_QUOTES_REDUCER_NAME);

        /**
         *  Keeping Enrollment Flow in saved quote data for now until backend updates 
         * & we move to a more generic reducer for enrollment flow
         * */

        individualPlanPayload.enrollment.enrollmentFlow = savedQuotesData?.enrollmentFlow ? savedQuotesData.enrollmentFlow : ENROLLMENT_FLOW.OEP;

        /** approvalFlow logic for MN */
        if (savedQuotesData?.enrollmentFlow === ENROLLMENT_FLOW.SEP_ELECTRONIC && environment.initData.brand.ASPID === "MN"){
            individualPlanPayload.approvalFlow = true;

            // Save-quote workflow, this must be false
            if (this.isSavedApp) {
                individualPlanPayload.approvalFlow = false;
            }
        } else {
            individualPlanPayload.approvalFlow = false;
        }

        /** If you've saved a quote during this session */
        if (savedQuotesData.saveQuoteFlowActivated) {

            /**
             * Referral Id - necessary for updating ( similar to application tracking id )
             * This will be null unless coming from the dashboard
             **/
            if (savedQuotesData.referralId) {
                individualPlanPayload.referralid = savedQuotesData.referralId;
            }

            individualPlanPayload.enrollment.applicationType = URL_PARAM_REFERRAL_TYPE.SAVED_QUOTE;
            
            individualPlanPayload.enrollment.enrollmentChannel = savedQuotesData.enrollmentChannel;
            individualPlanPayload.enrollment.producerInd = savedQuotesData.producerInd; // this might be true during producer->consumer referral, maintain it

            if(savedQuotesData.enrollmentFlow === ENROLLMENT_FLOW.SEP_ELECTRONIC || savedQuotesData.enrollmentFlow === ENROLLMENT_FLOW.SEP_PAPER){
                individualPlanPayload.enrollment['special-enrollment-child-date'] = payloadStates[INDIVIDUAL_MARKET_STATE_NAME]['special-enrollment-child-date']; 
            }
        }
        
        const agentInfo = await this.getAgentData();
        if (agentInfo) {
            individualPlanPayload.agentInfo = agentInfo;
            /** Producer Indicator - override all other values if a producer is actively logged in and interacting with this app */
            individualPlanPayload.enrollment.producerInd = true;
        }

        return individualPlanPayload;
    }

    async getAgentData(): Promise<AgentInfo> {
        const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

        if (!loginInfo.userId) {
            return null;
        }

        const selectedAgency = await this.entitlementsHelperService.getSelectedAgencyPromise();

        const agentInfo: AgentInfo = {
            producerReferredAppInd: "N",
            firstName: loginInfo.userInfo.firstName,
            middleName: loginInfo.userInfo.middleInitial,
            lastName: loginInfo.userInfo.lastName,
            producerId: selectedAgency?.npnNo || loginInfo.userInfo.npnNo,
            producerNumber: selectedAgency?.npnNo || loginInfo.userInfo.npnNo,
            agencyId: selectedAgency?.agencyId,
            agencyNumber: selectedAgency?.agencyId,
            npnNumber: selectedAgency?.npnNo || loginInfo.userInfo.npnNo,
            agencyName: selectedAgency?.agencyName,
            email: loginInfo.userInfo.email,
            producerUserId: loginInfo.userId,
            businessPhone: null,
            phoneNumber: null
        };
        return agentInfo;

    }

    getSEPData(data: {
        specialEnrollmentState: SpecialEnrollmentCircumstanceStateStructure,
        specialEnrollmentDocumentationState: LifeEventStateStructure,
        effDate,
        individualMarketInfo: IndividualMarketStateStructure
    }): EnrollmentApplicationSEPData {
 
        const lifeEvent = data.specialEnrollmentState.lifeEvent;
        const lifeEventdate = data.specialEnrollmentState.dateOfLifeEvent;
        
        /** 
         * Capture document upload tracking id(s)
         */
        let documents = data.specialEnrollmentDocumentationState.documents.map(d => {
            const returnable = {
                doctype: d.doctype,
                documentcontrolnumber: d.displayableFileObj.documentRecord
            };
            if (!d.doctype) {
                delete returnable.doctype;
            }
            return returnable;
        });
        
        /**
         * If they are all the same, as they will be when forced via forms-as-json config from document-upload.json files
         * then we'll only pass in one instance of the file - because later, when this is returned to us, we will want only 1 instance
         *   to know we are dealing with a "merged document upload" flow
         **/
        const areAllDocumentsSameControlNumber = Array.from(new Set(documents.map(d => d.documentcontrolnumber))).length === 1;

        /**
         * These are used only for the MN flow today, they are used to populate the checkboxes on the print PDF
         */
        // This has duplicatish functionality in the sep-application-review-dashboard.service.ts, but ran out of time to sync
        const documentUploadTypes = (() => {
            const array: DOCUMENT_UPLOAD_TYPES[] = [];
            data.specialEnrollmentDocumentationState.documents.forEach(d => {
                const docDescription = d.displayableFileObj.documentDescription;
                if (docDescription) {
                    const type = DOCUMENT_UPLOAD_TYPES[docDescription]
                    if (type) {
                        array.push(DOCUMENT_UPLOAD_TYPES[docDescription]);
                    }
                }
            })

            // No need of multiple
            return Array.from(new Set(array));
        })();
       
        const sepInfo: EnrollmentApplicationSEPData = {
            fullName: `${data.individualMarketInfo.ratingInfo.subscriber?.[0].firstName} ${data.individualMarketInfo.ratingInfo.subscriber?.[0].lastName}`,
            isAttested: true,
            documentcontrolnumber: areAllDocumentsSameControlNumber ? [documents[0]] : documents,
            documentUploadType: documentUploadTypes,
            dateSubmitted: this.date.getTodayAsMoment().format('ddd MMM DD YYYY'),
            lifeEvent: {
                categoryId: lifeEvent.portalTypeId,
                date: lifeEventdate ? this.date.getDateAsFormattedString( new Date(data.specialEnrollmentState.dateOfLifeEvent), 'MM/DD/YYYY') : null, // 
                eventCd: lifeEvent.lifeEventDescription,
                eventId: lifeEvent.lifeEventId,
                calculatedEffectiveDate: this.date.getDateAsFormattedString(data.effDate, 'MM/DD/YYYY'),
                requestedEffectiveDate: this.date.getDateAsFormattedString(data.effDate, 'MM/DD/YYYY')
            }
        };

        /** Remove these 2 fields if null; These fields require a value or lack of existence or will fail the transformation utility */
        if (!sepInfo.lifeEvent.categoryId) { delete sepInfo.lifeEvent.categoryId; }
        if (!sepInfo.lifeEvent.date) { delete sepInfo.lifeEvent.date; }

        return sepInfo;
    }

    getProductInfo(selectedPlan) {
        let productInfo;

        const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');
        const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');

        let region = '';
        if (zipCountyState) {
            region = zipCountyState.county && zipCountyState.county.region;
        }
        selectedPlan = this.plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment)[0];

        /** ARCHIVAL PLAN-DETAILS TO BE STORED - not read on backend */
        productInfo.planDetails = selectedPlan;

        // Single-Attributes, specifically named - actually read on backend

        /** Product Info */
        productInfo.groupNumber = selectedPlan.attributes?.GROUP_NO;
        productInfo.merchantId = selectedPlan.attributes?.BILL_MERCHANT_NAME;
        productInfo.region = region;
        productInfo.lob = selectedPlan.attributes?.LINE_OF_BUSINESS;
        productInfo.planArea = selectedPlan.attributes?.PLAN_AREA;
        productInfo.planId = selectedPlan.attributes?.PLAN_ID;
        // Subname is the place where the string has digit with a space in front of it.
        const nameBreakdown = /(.*?)\s(\d+\s?.*)/.exec(selectedPlan.attributes?.PRODUCT_NAME);
        const subName = nameBreakdown?.[2];
        productInfo.planName = nameBreakdown?.[1] || selectedPlan.attributes?.PRODUCT_NAME;
        productInfo.subName = subName || "";

        productInfo.hiosId = selectedPlan.attributes?.HIOS_ID;
        productInfo.ratingEntity = selectedPlan.attributes?.RATING_ENTITY;
        productInfo.premiumAmount = '$' + selectedPlan?.price;

        return productInfo;
    }

    getSubscriberData(individualMarketState: IndividualMarketStateStructure): EnrollmentApplicationSubscriberPerson {
        
        const personalInfo = individualMarketState.ratingInfo.subscriber[0] as EnrollmentApplicationSubscriberPerson;

        const reconcileAttestationSignatures = (): void => {
            /**
             * You can sign with formControlName firstName or subscriberAttestationFirstName with the below
             * 
             * WHY? In bulk enrollment, when you have fields with the same formControlName *somewhere* in the same context it will be overwritten by the flattening functionality
             * BUT WHY THIS SUBMIT SERVICE? This service relies on forms-as-json constructed values, as of the writing of this, HM uses the "firstName" pattern, but doesn't rely on it in bulk - so they don't care; but MN does care about the individual eSignature fields ( firstName/lastName ) and thus, we need to include them in bulk - which means they if they use "firstName/lastName" they will overwrite.
             * 
             * Examples of things which overwrite:
             *  personalInfo.firstName is overwritten by
             *  personalInfo.x.firstName
             *  personalInfo.spouseSignature.firstName
             */

            // First setup some normalized data structures
            // 1) uses 'firstName'
            // 2) uses 'subscriberAttestationFirstName'
            const signaturesAsPayloadData = {
                subscriber: {
                    firstName: (personalInfo.eSignatureFullName as eSignatureFieldPayload)?.firstName,
                    lastName: (personalInfo.eSignatureFullName as eSignatureFieldPayload)?.lastName
                },
                spouse: {
                    firstName: (personalInfo.eSignatureSpouseDomesticFullName as eSignatureFieldPayload)?.firstName,
                    lastName: (personalInfo.eSignatureSpouseDomesticFullName as eSignatureFieldPayload)?.lastName
                },
                producer: {
                    firstName: (personalInfo.eSignatureProducerFullName as eSignatureFieldPayload)?.firstName,
                    lastName: (personalInfo.eSignatureProducerFullName as eSignatureFieldPayload)?.lastName
                }
            }
            const signaturesAsFormData = {
                subscriber: {
                    firstName: (personalInfo.eSignatureFullName as eSignatureFieldFormSubscriber)?.subscriberAttestationFirstName,
                    lastName: (personalInfo.eSignatureFullName as eSignatureFieldFormSubscriber)?.subscriberAttestationLastName
                },
                spouse: {
                    firstName: (personalInfo.eSignatureSpouseDomesticFullName as eSignatureFieldFormSpouse)?.spouseAttestationFirstName,
                    lastName: (personalInfo.eSignatureSpouseDomesticFullName as eSignatureFieldFormSpouse)?.spouseAttestationLastName
                },
                producer: {
                    firstName: (personalInfo.eSignatureProducerFullName as eSignatureFieldFormProducer)?.producerAttestationFirstName,
                    lastName: (personalInfo.eSignatureProducerFullName as eSignatureFieldFormProducer)?.producerAttestationLastName
                }
            }

            // Second, populate the ACTUAL fields which DEMAND firstName/lastName with the fields from the forms
            // This is essentially us proxying these values, which, maybe we should have always done.
            personalInfo.eSignatureFullName = {
                firstName: signaturesAsFormData.subscriber.firstName || signaturesAsPayloadData.subscriber.firstName,
                lastName: signaturesAsFormData.subscriber.lastName || signaturesAsPayloadData.subscriber.lastName
            }
            
            personalInfo.eSignatureSpouseDomesticFullName = {
                firstName: signaturesAsFormData.spouse.firstName || signaturesAsPayloadData.spouse.firstName,
                lastName: signaturesAsFormData.spouse.lastName || signaturesAsPayloadData.spouse.lastName
            }

            personalInfo.eSignatureProducerFullName = {
                firstName: signaturesAsFormData.producer.firstName || signaturesAsPayloadData.producer.firstName,
                lastName: signaturesAsFormData.producer.lastName || signaturesAsPayloadData.producer.lastName
            }

            // Finally, null out the eSignatureFields of SPOUSE and PRODUCER if there is no spouse or producer engagement
            if ( ! (personalInfo.eSignatureSpouseDomesticFullName.firstName && personalInfo.eSignatureSpouseDomesticFullName.lastName) ) {
                delete personalInfo.eSignatureSpouseDomesticFullName;
            }
            if ( ! (personalInfo.eSignatureProducerFullName.firstName && personalInfo.eSignatureProducerFullName.lastName) ) {
                delete personalInfo.eSignatureProducerFullName;
            }
        }


        if(!this.isSavedApp){
        //if this line is run for a saved app, it will take the date out of utc format making it unable to be correctly absorbed by the date-input component in forms & doesn't display
        //this saves the formatting until the app is properly submitted
            personalInfo.dob = moment.utc(personalInfo.dob).format('MM/DD/YYYY');
        }
        
        this.removeEmptyKeys(personalInfo);

        personalInfo.relationship = 'SUBSCRIBER';

        personalInfo.zipCode = personalInfo.zipCode;
        personalInfo.tobaccoIndicator = ['Y', true, 'true'].includes(personalInfo.tobaccoIndicator) ? true : false;

        if (personalInfo.tobaccoLastUsed) {
            personalInfo.tobaccoLastUsed = this.date.getDateAsFormattedString(personalInfo.tobaccoLastUsed, 'MM/DD/YYYY');
        }

        if (personalInfo.residencySince) {
            personalInfo.residencySince = this.date.getDateAsFormattedString(personalInfo.residencySince, 'MM/DD/YYYY');
        }

        if (personalInfo.isHispanic === IS_HISPANIC.OTHER) {
            personalInfo.isHispanic = IS_HISPANIC.NO
        }

        if (personalInfo.nonHispanicRaceEthnicity === NON_HISPANIC_RACE_ETHNICITY.OTHER) {
            personalInfo.nonHispanicRaceEthnicity = NON_HISPANIC_RACE_ETHNICITY.RACE_NOT_LISTED_ABOVE
        }

        if (personalInfo.nonHispanicRaceEthnicity === NON_HISPANIC_RACE_ETHNICITY.PACIFIC_ISLANDER_RACE_NOT_LISTED_ABOVE) {
            personalInfo.nonHispanicRaceEthnicity = NON_HISPANIC_RACE_ETHNICITY.NATIVE_HAWAIIAN
        }

        if (!!personalInfo.languageRead) {
            personalInfo.languageReadCode = "5";
        }

        reconcileAttestationSignatures();

        /** CURRENTLY MN ONLY */
        if (!!personalInfo.languageWritten) {
            personalInfo.languageWrittenCode = "6";
        }

        if (!!personalInfo.languageSpoken) {
            personalInfo.languageSpokenCode = "7";
        }

        if (this.zipCountyState.county.brand === "MINCR") {

            /** mailingAddressExists and sameMailingAddress drive the same logic, independently - one should be boolean, the other null */
            if (!personalInfo.mailingAddressExists) {
                personalInfo.mailingAddressExists = null;
            }

            /** Checkbox being TRUE, means "SAME" is FALSE [ sending FALSE to payload ] */
            if (personalInfo.sameMailingAddressProxy) {
                personalInfo.sameMailingAddress = false;
                delete personalInfo.sameMailingAddressProxy;
            } else {
                personalInfo.sameMailingAddress = true;
            }

            if (personalInfo.isMailingBillingProxy) {
                personalInfo.isMailingBilling = false;
                delete personalInfo.isMailingBillingProxy;
            } else {
                personalInfo.isMailingBilling = true;
            }

        }

        return personalInfo;
    }

    /**
     * Returns subscriber ethnicity question answers for use in spouse/dependents
     * 
     * @param individualMarketState Data from the individual market payload states
     * @returns A collection of data from the subscriber
     */
    private getSubscriberEthnicityAlignmentData(individualMarketState: IndividualMarketStateStructure): {
        ethnicitySameForAllDependents: boolean;
        ethnicBackground: EthnicBackground;
        isHispanic: IS_HISPANIC
    } {

        let subscriber = individualMarketState?.ratingInfo?.subscriber?.[0];

        // Child Only
        if (!subscriber) {
            return {
                ethnicBackground: null,
                ethnicitySameForAllDependents: null,
                isHispanic: null
            }
        }

        return {
            ethnicitySameForAllDependents: subscriber.ethnicitySameForAllDependents,
            ethnicBackground: subscriber.ethnicBackground,
            isHispanic: subscriber.isHispanic
        }

    }

    /**
     * Return subscriber first/last name
     * 
     * @param individualMarketState Data from the individual market payload states
     * @returns first + last name string
     */
    private getSubscriberName(individualMarketState: IndividualMarketStateStructure): { firstName: string; lastName: string; } {
        let subscriber = individualMarketState?.ratingInfo?.subscriber?.[0];

        // child-only
        if (!subscriber) {
            return {
                firstName: null,
                lastName: null
            }
        }

        return {
            firstName: subscriber.firstName,
            lastName: subscriber.lastName
        };
    }

    getSpouseData(individualMarketState: IndividualMarketStateStructure): Person {
        const spouseInfo = individualMarketState.ratingInfo['spousal-partner'][0];
        spouseInfo.relationship = spouseInfo.relationship || APPLICANT_RELATION.SPOUSAL_PARTNER;
        if(!this.isSavedApp){
            spouseInfo.dob = moment.utc(spouseInfo.dob).format('MM/DD/YYYY');
        }
        spouseInfo.tobaccoIndicator = ['Y', true, 'true'].includes(spouseInfo.tobaccoIndicator) ? true : false;

        if (spouseInfo.tobaccoLastUsed) {
            spouseInfo.tobaccoLastUsed = this.date.getDateAsFormattedString(spouseInfo.tobaccoLastUsed, 'MM/DD/YYYY');
        }
        spouseInfo.zipCode = spouseInfo.zipCode;

        const subscriberEthnicityInfo = this.getSubscriberEthnicityAlignmentData(individualMarketState);
        if (subscriberEthnicityInfo.ethnicitySameForAllDependents) {
            spouseInfo.ethnicBackground = subscriberEthnicityInfo.ethnicBackground;
            spouseInfo.isHispanic = subscriberEthnicityInfo.isHispanic;
        }

        if (spouseInfo.isHispanic === IS_HISPANIC.OTHER) {
            spouseInfo.isHispanic = IS_HISPANIC.NO
        }

        if (spouseInfo.nonHispanicRaceEthnicity === NON_HISPANIC_RACE_ETHNICITY.OTHER) {
            spouseInfo.nonHispanicRaceEthnicity = NON_HISPANIC_RACE_ETHNICITY.RACE_NOT_LISTED_ABOVE
        }

        if (spouseInfo.nonHispanicRaceEthnicity === NON_HISPANIC_RACE_ETHNICITY.PACIFIC_ISLANDER_RACE_NOT_LISTED_ABOVE) {
            spouseInfo.nonHispanicRaceEthnicity = NON_HISPANIC_RACE_ETHNICITY.NATIVE_HAWAIIAN
        }

        this.removeEmptyKeys(spouseInfo);

        return spouseInfo;
    }

    getDependentData(individualMarketState: IndividualMarketStateStructure): Person[] {
        const processedDependents: any[] = [];
        for (const [key, dependent] of Object.entries(individualMarketState.ratingInfo.dependents) as any) {
            dependent.relationship = dependent.relationship || 'DEPENDENT';
            if(!this.isSavedApp){
                dependent.dob = moment.utc(dependent.dob).format('MM/DD/YYYY');
            }
            dependent.eSignature = true;
            dependent.tobaccoIndicator = ['Y', true, 'true'].includes(dependent.tobaccoIndicator) ? true : false;
            if (dependent.tobaccoLastUsed) {
                dependent.tobaccoLastUsed = this.date.getDateAsFormattedString(dependent.tobaccoLastUsed, 'MM/DD/YYYY');
            }

            if (dependent.residencySince) {
                dependent.residencySince = this.date.getDateAsFormattedString(dependent.residencySince, 'MM/DD/YYYY');
            }

            const subscriberEthnicityInfo = this.getSubscriberEthnicityAlignmentData(individualMarketState);
            if (subscriberEthnicityInfo.ethnicitySameForAllDependents) {
                dependent.ethnicBackground = subscriberEthnicityInfo.ethnicBackground;
                dependent.isHispanic = subscriberEthnicityInfo.isHispanic;
            }

            if (dependent.isHispanic === IS_HISPANIC.OTHER) {
                dependent.isHispanic = IS_HISPANIC.NO
            }

            if (dependent.nonHispanicRaceEthnicity === NON_HISPANIC_RACE_ETHNICITY.OTHER) {
                dependent.nonHispanicRaceEthnicity = NON_HISPANIC_RACE_ETHNICITY.RACE_NOT_LISTED_ABOVE
            }

            if (dependent.nonHispanicRaceEthnicity === NON_HISPANIC_RACE_ETHNICITY.PACIFIC_ISLANDER_RACE_NOT_LISTED_ABOVE) {
                dependent.nonHispanicRaceEthnicity = NON_HISPANIC_RACE_ETHNICITY.NATIVE_HAWAIIAN
            }

            dependent.guardian = this.getSubscriberName(individualMarketState);

            this.removeEmptyKeys(dependent);

            processedDependents.push(dependent);
        }

        return processedDependents;
    }

    async submitApp(redirectUrl) {
        this.isSavedApp = false;
        const enrollmentPersonInfo: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
        let app: EnrollPayloadSubmitRequest = await this.generateApp(enrollmentPersonInfo) as EnrollPayloadSubmitRequest;
        app.submitStatus = app.approvalFlow ? APP_STATUS.IN_PROGRESS : APP_STATUS.SUBMITTED;
        const response = await this.submit(app);
        return this.handleSubmitResponse(app, response, redirectUrl);
    }

    /**
     * 
     * @param configs Contains configuration information for saving enrollment progress
     * @returns 
     */
    async saveApp(saveAppArgs: {
        saveQuoteMetaData: SaveQuoteMetaData,
        quoteButtonPage: string,
        formConfig?: FormConfig<FormNavigationConfig>
    }): Promise<SubmitAppResponse | HttpErrorResponse> {
        this.isSavedApp = true; 
        this.quoteButtonPage = saveAppArgs.quoteButtonPage;
        const enrollmentPersonInfo: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
        let app: EnrollPayloadSaveRequest = await this.generateApp(enrollmentPersonInfo) as EnrollPayloadSaveRequest;
        app.saveQuoteData = this.updateSaveQuoteMetaData({
            saveQuoteMetaData: saveAppArgs.saveQuoteMetaData,
            formConfig: saveAppArgs.formConfig
        }); // attach our specific state data for retrieval later
        app.submitStatus = APP_STATUS.IN_PROGRESS;
        const response = await this.submit(app);

        return response;
    }

    async resaveApp(retrievedApp: EnrollPayloadSaveRequest): Promise<SubmitAppResponse | HttpErrorResponse> {
        retrievedApp.saveQuoteData = this.updateSaveQuoteMetaData({
            saveQuoteMetaData: retrievedApp.saveQuoteData,
            formConfig: null
        }); // attach our specific state data for retrieval later
        const response = await this.submit(retrievedApp);
        return response;
    }

    /**
     * Final Submission - requires complete enrollment payload. 
     * Typically, you won't call this unless you have the exact payload already available. ( if it is directly returned from a service )
     */
    public async submit(app: EnrollPayloadSubmitRequest | EnrollPayloadSaveRequest): Promise<SubmitAppResponse | HttpErrorResponse> {
        const basicUserInfo: BasicUserInfo = this.loggedInUserService.getUserData().basicUserInfo;
        let secureService = false;

        if (basicUserInfo) {
            secureService = true;
        }

        return await this.electionQuestionsService.submitApplication(app, secureService);

    }

    handleSubmitResponse(app, response, redirectUrl): boolean {

        if (!(response instanceof HttpErrorResponse)) {

            // Introducing a new field which just carries some custom info from this service to the confirmation page
            const extraInfo = {
                spouseRelation: (() => {
                    const spouseArray = app.applicant
                        .filter(applicant => {
                            if (
                                applicant.relationship === APPLICANT_RELATION.SPOUSAL_PARTNER ||
                                applicant.relationship === APPLICANT_RELATION.DOMESTIC_PARTNER
                            ) {
                                return true;
                            }
                        })
                    if (spouseArray.length > 0) {
                        return spouseArray[0].relationship;
                    }   
                })()
            };

            let confirmationData: EnrollmentAppStateStructure = {
                appId: response.appTrackingId,
                submittedDate: this.dateService.getTodayAsMoment().format('MM/DD/YYYY hh:mm:ss A'),
                submittedPlan: this.getSelectedPlan(),
                submittedApplicantName: app?.applicant?.[0]?.firstName + ' ' + app?.applicant?.[0]?.lastName,
                submittedEffectiveDate: app?.enrollment?.effectiveDate || app?.enrollment?.coverageDate,
                saveElectionAppIn: [],
                extraInfo: extraInfo
            };

            // backup data we need here
            sessionStorage.setItem('confirmationBackup', JSON.stringify(confirmationData));

            this.ngRedux.dispatch(saveExtraInfo(extraInfo));
            this.ngRedux.dispatch(saveApplicationSubmissionInfo(confirmationData));

            const alertDuration = 3000; // ms

            this.snackBar.open(`Successfully submitted application.`, 'OK', {
                duration: alertDuration,
                panelClass: 'positive-panel-class'
            });

            setTimeout(() => {
                this.windowLocationService.goToUrl(redirectUrl);
            }, alertDuration);

            return true;
        }
        else {
            console.log(response);
            return false;
        }
    }

    getSaveQuoteData(urls: SaveQuoteDataUrls): SaveQuoteMetaData {
        const enrollmentAppState: EnrollmentAppStateStructure = this.reducerUtilityService.getState(ENROLLMENT_APP_STATE_NAME);
        const savedQuotesState: SavedQuotesStateStructure = this.reducerUtilityService.getState(SAVED_QUOTES_REDUCER_NAME);
        
        const collectedStateData = (): SaveQuoteDataLockedInStateStructure => {
            const stateObj: SaveQuoteDataLockedInStateStructure = {
                appStates: {
                    effectiveDate: this.reducerUtilityService.getReducerFromApplicationState(EFFECTIVE_DATE_STATE_NAME)
                },
                componentStates: {
                    enrollmentApp: enrollmentAppState.appId ? enrollmentAppState : null, // previously saved ? maintain : clear
                    PlanDetails: this.reducerUtilityService.getState(PLAN_DETAILS_STATE_NAME),
                    Plans: this.reducerUtilityService.getState(PLAN_STATE_NAME),
                    ZipCounty: this.reducerUtilityService.getState(ZIP_COUNTY_STATE_NAME),
                    LifeEvent: this.reducerUtilityService.getState(LIFE_EVENT_DOCUMENT_UPLOAD_REDUCER)
                },
                payloadStates: {}
            };

            // INDIVIDUAL MARKET
            stateObj.payloadStates[INDIVIDUAL_MARKET_STATE_NAME] = this.reducerUtilityService.getPayloadStates()[INDIVIDUAL_MARKET_STATE_NAME];
            
            // SPECIAL ENROLLMENT
            if (savedQuotesState.enrollmentFlow === ENROLLMENT_FLOW.SEP_ELECTRONIC || savedQuotesState.enrollmentFlow === ENROLLMENT_FLOW.SEP_PAPER){
                // Old-World SEP flow ( where questions are only: is there a circumstance and have you adopted [ followed by the date of adoption ] )
                const childDatePath = this.reducerUtilityService?.getPayloadStates()?.['special-enrollment-child-date']
                stateObj.payloadStates[INDIVIDUAL_MARKET_STATE_NAME]['special-enrollment-child-date'] = childDatePath?.childAcquisitionDate ? childDatePath.childAcquisitionDate : "";
                
                // New-World SEP Flow ( content is delivered with a series of page navigations, ending with a defined life event + date of life event - this could include adoption )
                stateObj.payloadStates[SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_NAME] = this.reducerUtilityService.getPayloadStates()[SPECIAL_ENROLLMENT_CIRCUMSTANCE_STATE_NAME];
            }

            return stateObj;
        }
        
        let saveQuoteMetaData: SaveQuoteMetaData = {
            state: collectedStateData(),
            enrollmentFlow: savedQuotesState.enrollmentFlow,
            urls: urls
        };

        if (savedQuotesState.saveQuoteData?.actionList) {
            saveQuoteMetaData.actionList = savedQuotesState.saveQuoteData.actionList;
        }

        return saveQuoteMetaData;
    }

    /**
     * 
     * @param data this is the returnUrls needing to be passed along to allow for resumption navigation
     * @param quoteButtonPage this tracks which of the various pages you're initiating save from ( drives some custom data additions for save  )
     * @param formConfig if we're invoking this on a page with forms, we can use this data
     * @returns 
     */
    async saveQuote(data: {
        urls: SaveQuoteDataUrls,
        quoteButtonPage: string,
        formConfig?: FormConfig<FormNavigationConfig>
    }): Promise<SubmitAppResponse | HttpErrorResponse> {
        return await this.saveApp({
            saveQuoteMetaData: this.getSaveQuoteData(data.urls),
            quoteButtonPage: data.quoteButtonPage,
            formConfig: data.formConfig
        });
    }

    getSelectedPlan(): Product<PlanAttributes, SummaryView> {
        let selectedPlan: Product<PlanAttributes, SummaryView>;
        try {
            const planState: PlansStateStructure
                = this.reducerUtilityService.getState('Plans');

            const plansFromState
                = this.planUtilityService.getPlansByProductGroupAsArray();

            selectedPlan = plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment)[0];
        } catch {
            selectedPlan = null;
        }

        return selectedPlan;
    }

    axwayEbillCall(payload: any): Promise<EBillTransferResponseInterface> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            // added in global endpoint 
            url: API_ENDPOINTS.EBILL.SSO_URL,        
            POST_OR_PUT_PAYLOAD: payload
        });
        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
        return this.httpClient.makeRequest(requestConfig);
    }

    removeEmptyKeys(obj) {
        const newregex: RegExp = new RegExp('^[0-9]*a?$');
        if (obj) {
            for (const [key, value] of Object.entries(obj)) {
                if (key === undefined || value === undefined ||
                    String(key).match(newregex) || value === '' ||
                    key === '' || value === null || key === null) {
                    delete obj[key];
                }
            }
        }
    }

    async setOnExchangeEnrollmentPayLoad(): Promise<OnExchangeEnrollmentNormalizedResponse<OnExchangeEnrollResponse>> {

        const buildApplicantTransactionGroup = (
            data: EligibilityResponsePayload,
            activeProduct: Product<OnExchangePlanAttributes, SummaryView>
        ): TransactionGroup => {

            const hiosIdArray = activeProduct.attributes.HIOS_ID.split('-');

            /** Returnable */
            const transactionGroup: TransactionGroup = {
                insurancePlan: {
                    insurancePlanStandardComponentIdentification: hiosIdArray[0],
                    insurancePlanVariant: hiosIdArray[1],
                    issuer: hiosIdArray[0].substring(0, 5)
                },
                insurancePolicyEffectiveDate: data.effectiveDate,
                applicant: []
            };

            /** APTC Attestations */
            const primaryPersonId
                = data.primaryTaxFilerPersonReference ? data.primaryTaxFilerPersonReference.personId : null;

            const jointPersonId
                = data.jointTaxFilerPersonReference ? data.jointTaxFilerPersonReference.personId : null;

            /** Populate Applicant object */
            data.applicants.forEach(applicant => {

                const parseTobaccoInd = ['Y', true, 'true'].includes(applicant.tobaccoInd) ? true : false;

                const person: OnExchangeEnrollApplicant = {
                    personID: applicant.personID,
                    fullName: applicant.fullName,
                    dateOfBirth: applicant.dateOfBirth,
                    gender: applicant.gender,
                    tobaccoUseIndicator: parseTobaccoInd,
                    tobaccoLastUsageDate: applicant.tobaccoDate ? applicant.tobaccoDate : null,
                    proposedSubscriberIndicator: applicant.isPrimary,
                    enrollmentPeriodCode: this.eligibilityManagerService.getEnrollmentPeriodForApplicant(applicant),
                    relationshipToSubscriberCode: this.eligibilityManagerService.getRelationshipCodeBasedOnPrimary(applicant),
                    specialEnrollmentReasonCode: null, // did not see this set anywhere in HCR....
                    attestationId: undefined, // set below
                    APTCAttestationIndicator: undefined // set below
                };

                if (applicant.personID === primaryPersonId || applicant.personID === jointPersonId) {
                    if (applicant.personID === primaryPersonId) {
                        person.attestationId = primaryPersonId;
                    } else {
                        person.attestationId = jointPersonId;
                    }
                    person.APTCAttestationIndicator = data.APTC ? true : false;
                } else {
                    person.APTCAttestationIndicator = false;
                }

                transactionGroup.applicant.push(person);

            });

            return transactionGroup;
        };

        const isProducer = (() => {

            const userInfoState: UserInfoStateStructure
                = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];

            if (userInfoState?.basicUserInfo?.userType) {
                if (
                    userInfoState.basicUserInfo.userType.toUpperCase() === USER_ROLE.AGENCY_ADMIN.toUpperCase() ||
                    userInfoState.basicUserInfo.userType.toUpperCase() === USER_ROLE.INTERNAL.toUpperCase() ||
                    userInfoState.basicUserInfo.userType.toUpperCase() === USER_ROLE.AGENT.toUpperCase()
                ) {
                    return true;
                }
            }

            return false;
        })();

        const buildAgentData = async (): Promise<Agent> => {
            const userInfoState: UserInfoStateStructure
                = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];

            const producerSubmissionData: Agent = {
                fullName: {
                    firstName: null,
                    lastName: null
                },
                npn: null
            };

            if (isProducer) {
                const selectedAgency = await this.entitlementsHelperService.getSelectedAgencyPromise();
                producerSubmissionData.fullName.firstName = userInfoState.basicUserInfo.firstName;
                producerSubmissionData.fullName.lastName = userInfoState.basicUserInfo.lastName;
                producerSubmissionData.npn = selectedAgency.npnNo || userInfoState.userInfo.npnNo;
            }

            return producerSubmissionData;
        };

        const buildAffectedInsurancePremium = (
            prospectData: ProspectState,
            activeProduct: Product<OnExchangePlanAttributes, SummaryView>
        ): AffectedInsurancePremium => {
            return {
                amount: Number(activeProduct.price).toFixed(2), // '1065.05',
                electedAPTCAmount: Number(prospectData.selectedMonthlyAptcForProspect).toFixed(2), // '1531.00',
                appliedAPTCAmount: Number(prospectData.appliedAPTC).toFixed(2), // '1065.05',
                individualResponsibilityTotalAmount: Number(prospectData.individualResponsibilityAmount).toFixed(2), // '0.00',
                rateArea: zipCountyState.county.ffmRatingArea, // 'WY002',
                insurancePlanVariantCategoryNumericCode: activeProduct.attributes.HIOS_ID.split('-')[1], // '01',
                APTCEligibilityIndicator: prospectData.data.APTC
            };
        };

        /** Prospect Data */
        const eligibilityState: OnExchangeEligibilityStateStructure
            = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];
        const matchedProspects = eligibilityState.prospects.filter(p => eligibilityState.currentProspectId === p.prospectId);
        if (matchedProspects.length < 1) {
            console.warn('Something is wrong, no prospects matched');
            return;
        }

        /** Plan Data */
        const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
        let selectedPlan: Product<PlanAttributes, SummaryView> = null;

        selectedPlan =
            this.plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment)[0];

        /** County Data */
        const zipCountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');

        /** Is Logged In? */
        const basicUserInfo: BasicUserInfo = this.loggedInUserService.getUserData().basicUserInfo;
        const secureService = basicUserInfo ? true : false;

        const enrollData: EligibilityResponsePayload = matchedProspects[0].data;
        const subscriber = enrollData.applicants[0];

        /** Populate eligibility manager with producer data from USER INFO or ENROLLMENT FORM ( marketplaceConsumerNpnComponent ) */
        let npnFromData = null;
        if (isProducer) {
            const producerData = await buildAgentData();
            this.eligibilityManagerService.setAgentInformation(matchedProspects[0].prospectId, {
                firstName: producerData.fullName.firstName,
                lastName: producerData.fullName.lastName,
                npn: producerData.npn
            });

            if (producerData.npn) { npnFromData = producerData.npn; }
        } else {
            const onExchangeEligibilityForm: OnExchangeEligibilityFormStateStructure
                = this.reducerUtilityService.getPayloadStates()[ON_EXCHANGE_ELIGIBILITY_FORM_REDUCER_NAME];
            const consumerNpnData: ConsumerNpnControlsAsJson = onExchangeEligibilityForm.marketplaceConsumerNpn;
            this.eligibilityManagerService.setAgentInformation(matchedProspects[0].prospectId, {
                firstName: consumerNpnData.producerFirstName,
                lastName: consumerNpnData.producerLastName,
                npn: consumerNpnData.npn
            });
            if (consumerNpnData.npn) { npnFromData = consumerNpnData.npn; }
        }

        const partnerWebsiteUserCode = npnFromData ? 'Agent' : 'Consumer';
        this.eligibilityManagerService.setPartnerWebsiteUserCode(matchedProspects[0].prospectId, partnerWebsiteUserCode);

        const onExchangePayload: NormalizedResponse<OnExchangeEnrollRequestPayload> = {
            baseMessage: {
                headerVersion: '1.0',
                uuid: null
            },
            payload: {
                customerData: {
                    fullName: {
                        firstName: enrollData.customerData.fullName.firstName,
                        lastName: enrollData.customerData.fullName.lastName
                    },
                    eMail: enrollData.customerData.emailAddress,
                    personID: 'Person1'
                },
                prospectId: matchedProspects[0].prospectId,
                partnerWebSiteUserCode: isProducer ? 'Agent' : 'Consumer', // if npn value from form exists, 'Agent', else Consumer',
                transactions: {
                    transaction: [
                        {
                            transactionType: 'policyCreate',
                            actionEffectiveDate: subscriber.effectiveDate, // '01/01/2022',
                            affectedInsurancePremium: buildAffectedInsurancePremium(matchedProspects[0], selectedPlan),
                            transactionGroup: buildApplicantTransactionGroup(enrollData, selectedPlan)
                        }
                    ]
                },
                agent: await buildAgentData(),
                appData: JSON.stringify(enrollData)
            }
        };

        // SUBMIT APPLICATION
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: '/cmcrst/x-services/applicant/onexchange/enroll',
            headers: new HttpHeaders({
                ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
            }),
            POST_OR_PUT_PAYLOAD: onExchangePayload
        });
        this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
        const response: OnExchangeEnrollmentNormalizedResponse<OnExchangeEnrollResponse> = await this.httpClient.makeRequest(requestConfig);
        return response;

    }

    private updateSaveQuoteMetaData(updateArgs: {
        saveQuoteMetaData: SaveQuoteMetaData,
        formConfig: FormConfig<FormNavigationConfig> | null
    }): SaveQuoteMetaData {
        const saveQuoteMetaData = updateArgs.saveQuoteMetaData;
        const customConfigs = updateArgs.formConfig?.form.customConfigs as { standaloneDocumentUpload?: boolean };
        const standaloneDocumentUpload = customConfigs?.standaloneDocumentUpload;

        /**
         * A document upload request was active:
         * 1) A consumer has proceeded to this point; 
         * 1a) the consumption succeeded in the validation of the standalone page, and thus documents are upload - change needed
         * 2) A producer has proceeded to this point
         * 2a) re-save
         * 2ai) ( documents might not yet be uploaded ) - no change needed
         * 2aii) ( documents uploaded ) - change status to complete
         * 2b) app-submission ( documents are uploaded and app submitted ) - no change needed
         * 3) A producer is saving an application and needs actionList
         */
        if (standaloneDocumentUpload === true) {
            if (saveQuoteMetaData.actionList?.documentUpload?.status === SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS.STEP_1_REQUESTED) {
                saveQuoteMetaData.actionList.documentUpload.status = SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS.STEP_2_COMPLETED;
            }
        } else {
            // PRODUCER FLOW
            const componentStates = this.reducerUtilityService.getComponentStates();
            const specialEnrollmentDocumentationState: LifeEventStateStructure = componentStates['LifeEvent'];

            // Always save this actionlist status, unless documents are not required
            if (specialEnrollmentDocumentationState.isDocumentUploadRequired) { 

                // Add .actionList
                if (!saveQuoteMetaData.actionList) {
                    saveQuoteMetaData.actionList = {};
                }

                // Add .documentUpload && .documentUpload.status
                if (!saveQuoteMetaData.actionList.documentUpload) {

                    // Status: PRODUCER-SAVED
                    saveQuoteMetaData.actionList.documentUpload = { status: SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS.STEP_0_SAVED };
                }

            }

            // REQUIREMENT and THRESHOLD CHECK
            if (
                specialEnrollmentDocumentationState.isDocumentUploadRequired &&
                specialEnrollmentDocumentationState.documents.length >= specialEnrollmentDocumentationState.minRequired
            ) {
                // Status: COMPLETE
                saveQuoteMetaData.actionList.documentUpload.status = SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS.STEP_2_COMPLETED;
            }
        }

        return saveQuoteMetaData;
    }

}
